import * as React from 'react';
import { InfoWindow, Marker } from 'react-google-maps';

import { IPlace } from '../models/place';

import { getLocale } from '../../utils/pathHelper';

// (rx ry x-axis-rotation large-arc-flag sweep-flag x y)+
const iconTypes = {
  dot: {
    path: 'm -5, 0 a 5,5 0 1,0 10,0 a 5,5 0 1,0 -10,0',
    fillColor: '#007bff',
    fillOpacity: 0.6,
    strokeColor: '#007bff',
    strokeOpacity: 0.9,
    strokeWeight: 1,
    scale: 1,
  },
};

interface IMapMarker {
  iconType?: 'dot';
  isOpen: boolean;
  handleClick: () => void;
  place: IPlace;
}

const renderContent = (place: IPlace) => {
  return place[`name_${getLocale({ underscore: true })}`] || 'unknown';
}

const MapMarker = ({ iconType, isOpen, handleClick, place }: IMapMarker) => {
  const position = { lat: Number(place.latitude), lng: Number(place.longitude) };
  const icon = iconTypes[iconType] || '';
  return (
    <React.Fragment>
      {isOpen &&
        <InfoWindow position={position}>
          <div>
            {renderContent(place)}
          </div>
        </InfoWindow>
      }
      <Marker position={position} onClick={handleClick} icon={icon} />
    </React.Fragment>
  );
}

export default MapMarker;
